<template>
  <PortfolioFormLayout :loading="loading">
    <template #header>
      <h5 class="my-2">{{ isUpdateForm ? 'Update' : 'Create' }} Product Type</h5>
    </template>
    <template #body>
      <ProductTypeFormPresentational
        v-model:description="description"
        v-model:name="name"
        :error-messages="errorMessages"
        :loading="loading"
        :server-error="serverError"
        @submit="submit"
      />
    </template>
  </PortfolioFormLayout>
</template>
<script lang="ts" setup>
import {ProductTypeCreateUpdate} from '@/stores/userManagement/userManagement';

const props = defineProps<{
  isUpdateForm: boolean;
  id?: number;
}>();

const router = useRouter();

// Stores
const productTypesStore = useProductTypesStore();
const getProductTypes = computed(() => productTypesStore.getProductTypes);

const loading = ref(false);

// Form data
const name = ref('');
const description = ref('');
const errorMessages = ref(new Map());
const serverError = ref(false);

const submit = async (form: globalThis.Ref<HTMLFormElement | null>) => {
  try {
    loading.value = true;
    const productType: ProductTypeCreateUpdate = {
      name: name.value,
      description: description.value,
    };
    if (!props.isUpdateForm) {
      await productTypesStore.createProductType(productType);
      router.go(-1);
    } else {
      const updateProductType: ProductTypeCreateUpdate = {
        ...productType,
        id: props.id,
      };
      await productTypesStore.updateProductType(updateProductType);
      router.go(-1);
    }
  } catch (errorMessage: any) {
    serverError.value = true;
    errorMessages.value = new Map();
    // Remove .was-validated for server-side validation response.
    form.value?.classList.remove('was-validated');
    if (typeof errorMessage !== 'string' && errorMessage.length > 0) {
      errorMessage.forEach((d: any) => errorMessages.value.set(d.loc[1], d.msg));
    }
    form.value?.classList.remove('was-validated');
    console.log(errorMessage);
  } finally {
    loading.value = false;
  }
};

const load = async () => {
  if (props.isUpdateForm === true) {
    // Try find the item in store state
    let item = getProductTypes.value.find((pt) => pt.id === props.id);
    // If the item is missing, try to fetch it
    if (item === undefined && props.id !== undefined) {
      try {
        const data = await productTypesStore.readProductTypeById(props.id);
        item = data;
      } catch (error) {
        console.log(error);
      }
    }
    if (item !== undefined) {
      // Set the form data
      name.value = item.name;
      description.value = item.description;
    }
  }
};

onMounted(() => load());
</script>
